import ThankYou from './ThankYou';
export { ThankYou as default };
